import { gql } from '@apollo/client'

// mutation name added
export default gql(`
    mutation createVirtualProgram($channelId: ID! $startTime: AWSDateTime! $endTime: AWSDateTime $project: String $module: String) {
        createVirtualProgram(
                input:{
                    channel: $channelId,
                    broadCastStartTime: $startTime
                    broadCastEndTime: $endTime
                    source:"MANUAL"
                    isFirstRun:false
                    isLiveTelecast:false
                    project:$project
            
                },
                module:$module
              )
              {
                id
                source
                isLiveTelecast
                channel{
                    id
                    name
                    icon{
                        id
                        fileName
                        aspectRatio {
                            aspectRatio
                            ratio
                            title          
                            resolutions {
                            url
                            }
                        }
                        settings {
                            aspectRatio
                            outputFormat
                            fileName
                            x1
                            y1
                            x2
                            y2
                        }
                    }
                    masterConfig{
                        id
                    }
                    configGroups{
                        id
                        name
                        streams{
                            url
                            fields{
                                name
                                value
                                isRequired
                                type
                            }
                            streamSchema{
                                id
                                levels{
                                    id
                                    name
                                }
                            }
                        }
                    }
                    activeConfigGroup{
                        id
                        name
                        streams{
                            url
                            fields{
                                name
                                value
                                isRequired
                                type
                            }
                            streamSchema{
                                id
                                levels{
                                    id
                                    name
                                }
                            }
                        }
                    }
                    defaultTrimStart
                    defaultTrimEnd
                }
                broadCastStartTime
                broadCastEndTime
            }
    }`
)
